// src/components/Layout.tsx
import React, { useContext } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ThemeContext } from "./ThemeContext";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <>
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
